export const maxFreeTenantLimit = 10;
